<template>
  <header class="header">
    <div class="gradient-line">
    </div>
    <section>
        <article>
            <p>Elephant presents</p>
            <h1>CALIFORNIA</h1>
            <h1 class="outline-text--white">CALLING</h1>
            <p>Dedicated to the communities affected by the 2018 wildfires.</p>
        </article>
        <aside>
            <div class="bear">
              <svg width="54px" height="30px" viewBox="0 0 54 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <!-- Generator: Sketch 51.3 (57544) - http://www.bohemiancoding.com/sketch -->
                  <desc>Created with Sketch.</desc>
                  <defs></defs>
                  <g id="4" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="CC-v4" transform="translate(-140.000000, -772.000000)" fill="#FFFFFF">
                          <path d="M140.170502,786.693356 C140.791425,786.156846 141.379553,785.55848 141.874542,784.902355 C142.455236,784.13261 142.557411,783.493594 142.766864,782.580253 C143.011006,781.515274 143.413148,780.487145 143.952593,779.537686 C144.85643,777.947456 146.345624,775.991802 147.891081,774.978295 C148.423239,774.629395 149.087888,774.432425 149.70269,774.594154 C150.097253,774.697976 150.440364,774.938228 150.814812,775.100834 C154.478403,776.690918 156.613737,771.495142 160.032603,772.040281 C160.743458,772.153607 161.355344,772.585126 161.993612,772.918526 C163.858858,773.892844 166.047393,774.054865 168.143664,773.888018 C170.239935,773.721172 172.300641,773.247247 174.391665,773.023811 C179.524628,772.475455 183.988423,774.919072 187.779988,778.204963 C187.945422,778.348413 188.120184,778.513212 188.149335,778.730653 C188.178632,778.948094 187.961892,779.196097 187.762206,779.106606 C188.819378,779.581116 189.034661,781.681243 189.07314,782.636405 C189.121677,783.843664 189.219188,785.026503 189.083343,786.230398 C188.938899,787.511356 188.668666,788.861919 189.150974,790.106173 C189.660977,791.42208 190.843645,792.264646 191.892947,793.125929 C193.158697,794.164733 193.867074,795.049705 193.953362,796.745512 C193.999421,797.652126 193.999275,798.560495 193.999129,799.468279 C193.999129,799.848764 194.015162,800.263467 193.909635,800.632839 C193.745804,801.207077 193.590865,801.109104 193.079114,801.280191 C192.663708,801.419254 192.229062,801.704252 190.415121,799.201705 C188.634705,796.745512 186.651249,795.804242 185.542916,795.748676 C184.434875,795.693109 183.908257,800.139319 183.658867,800.501819 C183.113009,801.29496 182.819455,801.890693 181.771903,801.954448 C180.547693,802.029171 179.319986,802.003289 178.095776,801.939241 C177.30563,801.898004 176.280378,802.183295 175.572585,801.706592 C174.740898,801.146538 175.622725,800.527116 176.137829,800.221938 C177.356936,799.499133 178.865517,799.862656 179.059519,798.583892 C179.253375,797.305273 178.976292,794.525624 178.56074,793.775182 C178.145042,793.024593 177.507794,792.80218 176.925934,792.83011 C176.34422,792.857747 173.240917,792.83011 172.077196,792.329717 C170.913622,791.829325 170.110066,791.356862 169.666674,791.495778 C169.223429,791.634695 169.305781,792.24198 169.466842,794.100978 C169.641604,796.116293 169.387113,798.07882 168.665181,799.976129 C168.529773,800.331902 168.369733,800.695863 168.078657,800.940211 C167.437474,801.478769 166.386423,801.281068 165.612456,801.266299 C165.063828,801.255917 164.514909,801.248313 163.966573,801.231204 C163.636434,801.220968 163.289679,801.159553 163.036937,800.946206 C162.555649,800.539838 162.765393,799.780476 163.28414,799.528086 C164.198471,799.083407 165.704574,799.723593 165.787655,798.250345 C165.856889,797.023638 164.966463,795.628476 164.392036,794.605903 C163.596788,793.190416 162.591068,791.888255 161.662744,790.556848 C161.468597,790.27843 161.268764,789.994162 160.991827,789.798509 C159.611658,788.823899 158.739451,790.701614 158.348386,791.753286 C157.881673,793.008215 157.627765,794.347664 156.937025,795.506229 C156.292198,796.587586 155.414015,797.517304 154.44313,798.30986 C152.728742,799.709848 150.582476,801.182803 148.36377,801.542524 C146.949202,801.77181 144.848267,801.529802 143.816019,800.390686 C143.360822,799.888392 145.804285,799.745381 146.054257,799.702098 C147.384432,799.47135 148.288851,798.669581 148.888202,797.466563 C150.509161,794.211965 151.865425,790.869045 152.881786,787.376241 C152.922452,787.236447 152.960349,787.075304 152.880183,786.953935 C152.828876,786.876141 152.739528,786.833589 152.653094,786.799372 C151.822136,786.470651 150.780414,786.522854 149.921179,786.693064 C148.863861,786.902755 148.284916,787.961154 147.297269,788.319266 C145.850781,788.84364 142.946581,789.14604 141.603726,788.22451 C140.966333,787.786996 139.503228,787.269641 140.170502,786.693356" id="Bear-Icon"></path>
                      </g>
                  </g>
              </svg>
            </div>
            <a class="button" href="https://www.eventbrite.com/e/elephant-studio-crawl-san-francisco-design-week-2019-tickets-63313109214" target="_blank" rel="noopener">RSVP</a>
        </aside>
    </section>
  </header>
</template>

<script>
  export default {
    name: 'Header'
  }
</script>

<style scoped>
.gradient-line{
  width: 100%;
  height: 100%;
  display: block;
  background: linear-gradient(#fff, #000) no-repeat center/2px 100%;
}
.header{
  background-color: #000;
  color: #FFF;
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  position: relative;

  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-row-gap: 15px;
}

section{
  text-align: center;
}

section h1{
  font-family: 'Vollkorn', serif;
}
.line{
  display: flex;
  justify-content: center;
}

.line > svg{
  height: 25vh;
  width: 1px;
}

aside{
  width: 83.33333%;
  position: absolute;
  left: 8.333335%;
  bottom: 40px;

  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}

@media screen and (min-width: 992px){
  section h1{
    font-size: 7.5vw;
    line-height: 6.25vw;
  }

  section p:first-of-type{
    margin-bottom: 2.5vw;
  }
}

@media screen and (max-width: 992px){
  section p:first-of-type{
    margin-bottom: 7vw;
  }
}

</style>
